module.exports = __webpack_public_path__ + "img/20190828162532675.ff0dc62b.jpg";